import { BaseLayout } from "@components/layouts/base.layout";
// import { StoriesLibSidebar } from "@pages/stories-lib/components/sidebar";
// import { usePageTransition } from "@/shared";
// import { useLocation } from "react-router-dom";

export const LibraryLayout = ({
  children,
  className,
  fallback,
  hideHeader,
  hideSidebar,
  title,
}: {
  children: React.ReactNode;
  className?: string;
  fallback?: React.ReactNode;
  hideHeader?: boolean;
  hideSidebar?: boolean;
  title?: string;
}) => {
  // const location = useLocation();
  const baseProps: {
    className?: string;
    fallback?: React.ReactNode;
    hideHeader?: boolean;
    transitionKey: string;
    hideSidebar?: boolean;
    title?: string;
  } = {
    transitionKey: "/pages/editor",
  };
  if (className !== undefined) baseProps.className = className;
  if (fallback !== undefined) baseProps.fallback = fallback;
  if (hideHeader !== undefined) baseProps.hideHeader = hideHeader;
  if (hideSidebar !== undefined) baseProps.hideSidebar = hideSidebar;
  if (title !== undefined) baseProps.title = title;
  return (
    <BaseLayout {...baseProps}>
      <div className="tw-pb-12">{children}</div>
    </BaseLayout>
  );
};

// const InnerTransition = ({ children }: { children: React.ReactNode }) => {
//   const { transitionClasses } = usePageTransition();
//   return <div className={transitionClasses}>{children}</div>;
// };
